module.exports = __webpack_public_path__ + "static/img/wjt_pay.dcbcb92.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/wjt_pay.jpg
// module id = Kfmf
// module chunks = 1